import angular from 'angular';
import 'ui-select';
import 'angular-bootstrap';
import './categoriesServices';

const categoriesControllers = angular.module('applicationModule.categoriesControllers', [
    'applicationModule.categoriesServices',
    'ui.bootstrap',
    'ui.select'
]);

categoriesControllers.controller('CategoryController', ['$scope', '$rootScope', '$stateParams', '$state', 'NgTableParams', 'Categories', 'AppsoupAPI', 'Permissions', 'growl', function ($scope, $rootScope, $stateParams, $state, NgTableParams, Categories, AppsoupAPI, Permissions, growl) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('categories');
    $scope.application_id = $stateParams.application_id;
    $scope.check = false;
    $scope.search = {};
    $scope.searchItem = null;
    if (angular.isDefinedNotNull($stateParams.page)) {
        $scope.search.page = $stateParams.page;
    }
    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: (params) => {
            $scope.isLoading = true;

            return Categories.getList($scope.application_id, params._params)
                .then((response) => {

                    params.total(response.categories.total);
                    params.count(response.categories.per_page);
                    params.page(response.categories.current_page);
                    $scope.search.page = response.categories.current_page;

                    if (angular.isDefinedNotNull($stateParams.searchCategories)) {
                        $scope.search = $stateParams.searchCategories;
                        $scope.searchCategories($scope.search);
                    }

                    return response.categories.data;
                })
                .finally(() => {
                    $scope.isLoading = false;
                    $scope.isFind = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.removeCategory = (id, index) => {
        Categories.remove(id).then((result) => {
            let data = result.data;
            if (data.success) {
                growl.success('MODULES.CATEGORIES.DELETE_CATEGORY');
                $scope.tableParams.data.splice(index, 1);
            } else {
                growl.error('MODULES.CATEGORIES.ERROR_DELETE');
            }
        });
    };

    $scope.searchCategories = (search) => {
        $scope.isFind = true;
        $scope.search.page = 1;
        const find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.searchItem = $scope.search;
        $scope.isFind = false;
    };

    $scope.clearSearch = () => {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.name)) {
            $scope.tableParams._params.name = undefined;
        }
        $stateParams.searchCategories = null;
        $scope.searchItem = null;
    };

    $scope.$watch('search', () => {
        $scope.check = false;
        angular.forEach($scope.search, (val) => {
            if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                $scope.check = true;
            }
        });
    }, true);
}]);

categoriesControllers.controller('CreateCategoryController', ['$scope', '$state', '$rootScope', '$stateParams', 'NgTableParams', 'Categories', 'AppsoupAPI', 'Permissions', 'growl', '$filter', function ($scope, $state, $rootScope, $stateParams, NgTableParams, Categories, AppsoupAPI, Permissions, growl, $filter) {
    const appId = $stateParams.application_id;
    $scope.editMode = false;
    $scope.isLoading = false;
    $scope.category = {
        app_id: appId,
        status: true
    };
    $scope.categories = [];
    $scope.tags = [];

    $scope.replaceChars = (text) => {
        const dict = {'ą': 'a', 'ę': 'e', 'ć': 'c', 'ł': 'l', 'ń': 'n', 'ó': 'o', 'ś': 's', 'ż': 'z', 'ź': 'z'};
        let str = angular.copy(text);
        str = str.replace(/\s+/g, '-').toLowerCase();
        str = str.replace(/[^\w ]/g, (char) => {
            return dict[char] || char;
        });
        str = str.replace(/[^0-9a-z-]+/g, '');
        str = str.replace(/[-]+/g, '-');

        return str;
    };

    $scope.generateSlug = () => {
        if ($scope.category.name) {
            $scope.category.slug = $scope.replaceChars($scope.category.name);
        }
    };

    $scope.$watch('category.slug', (oldValue, newValue) => {
        if ($scope.category.slug && oldValue !== newValue) {
            $scope.category.slug = $scope.replaceChars($scope.category.slug);
        }
    });

    if (angular.isDefined($stateParams.categoryId)) {
        $scope.editMode = true;
        $scope.isLoading = true;
        Categories.get($stateParams.categoryId, appId).then((result) => {
            let data = result.data;
            if (data.success) {
                $scope.editMode = true;
                $scope.category = data.category;
            }
        }).catch(() => {
            $state.go('appsoup.application.categories', {application_id: appId}, growl.error('ERROR.EMPTY_DATA'));
        }).finally(() => {
            $rootScope.doingResolve = false;
            $scope.isLoading = false;
        });
    }

    Categories.getCategories(appId, $scope.category.id).then((response) => {
        if (response.success) {
            $scope.categories = response.categories;
        }
    });

    $scope.searchTags = (text) => {
        text = $filter('removeSpecial')(text);

        Categories.search(appId, text).then((result) => {
            let data = result.data;
            if (data.success) {
                $scope.tags = data.tags;
            } else {
                growl.error(data['error']);
            }
        });
    };

    $scope.changeTags = () => {
        if (angular.isDefined($scope.category.tags)) {
            const tempTags = [];
            angular.forEach($scope.category.tags, (value) => {
                value = $filter('removeSpecial')(value);
                if (angular.isDefined(value) && tempTags.indexOf(value) === -1) {
                    tempTags.push(value);
                }
            });
            $scope.category.tags = tempTags;
        }
    };

    $scope.saveCategory = () => {
        const data = $scope.category;
        angular.forEach(data, (val) => {
            if (typeof val === 'string') {
                val.trim();
            }
        });
        Categories.save(data, $scope.editMode).then((result) => {
            let data = result.data;
            if (data.success) {
                const message = $scope.editMode ? 'MODULES.CATEGORIES.EDIT' : 'MODULES.CATEGORIES.SAVE';
                growl.success(message);
                $state.go('appsoup.application.categories', {'applicationId': appId});
            } else {
                $scope.formErrors = data.error;
                growl.error('MODULES.CATEGORIES.ERROR_SAVE');
            }
        }).finally(() => {
            $scope.isLoading = false;
        });
    };

    $scope.cancel = () => {
        $state.go('appsoup.application.categories', {'applicationId': appId});
    };

    $scope.inputErrors = {
        'name': [{error: 'required', msg: 'ERROR.REQUIRED'}],
        'slug': [{error: 'required', msg: 'ERROR.REQUIRED'}]
    };

}]);

export default categoriesControllers;
